import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2, Target, Award, Users } from "lucide-react";

export default function About() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/settings").then(r => setSettings(r.data)); }, []);
  const about = settings?.about || {};
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <div className="max-w-3xl mb-14">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700 mb-4">Tentang LSP</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-emerald-950 tracking-tight">{about.title}</h1>
        <p className="mt-6 text-lg text-slate-700 leading-relaxed">{about.body}</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {(about.points || []).map((p, i) => {
          const Icon = [CheckCircle2, Target, Award, Users][i % 4];
          return (
            <div key={i} className="bg-white rounded-2xl p-6 border border-slate-100 hover:shadow-lg transition-shadow">
              <Icon className="w-8 h-8 text-amber-500 mb-4" />
              <div className="font-display font-bold text-emerald-950">{p.title}</div>
              <div className="text-sm text-slate-600 mt-2">{p.desc}</div>
            </div>
          );
        })}
      </div>
      <div className="mt-16 rounded-3xl overflow-hidden">
        <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=2000&q=85" alt="Realestat Profesional" className="w-full h-96 object-cover" />
      </div>
    </div>
  );
}
